<div class="otto-up-container">
  <oc-logo-v1 logo="otto-up" fill-parent></oc-logo-v1>
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .otto-up-container {
    display: flex;
    align-items: center;
    height: 16px;
    padding-top: tokens.$oc-semantic-spacing-25;
    padding-bottom: tokens.$oc-semantic-spacing-25;
  }

  oc-logo-v1 {
    /*                                  */
    width: 52px;
    height: 13px;
  }
</style>
